<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Card Photo'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <div>
    <tidy-wrapper>


      @if (isMultiple) {
        <div class="container">
          @if (photoUrls.length > 0) {
            <div class="photo-grid">
              @for (photoUrl of photoUrls; track photoUrl; let i = $index) {
                <div class="photo-item">
                  <div class="photo-container">
                    <img class="img-photo" [src]="photoUrl"/>
                    <div class="photo-caption">
                      <span class="pencil-icon"></span>
                      <ion-textarea [(ngModel)]="captions[i]" tidyCustomTextarea placeholder="Add Caption" class="custom-textarea caption-input" [runNgAfterViewChecked]="true" />
                    </div>
                    <tidy-row class="text-center extra-top-padding extra-bottom-padding">
                      <tidy-text
                        [body]="'Delete Photo'"
                        class="red"
                        (action)="deletePhoto(i)" />
                    </tidy-row>
                  </div>
                </div>
              }
            </div>
          }
          <tidy-row class="extra-top-padding">
            <tidy-button
              [text]="'Retake Photo'"
              [action]="boundRetakeImage"
              class="secondary" />
          </tidy-row>
          <tidy-row class="extra-top-padding">
            <tidy-button
              [text]="'Save'"
              [action]="boundSave"
              class="primary" />
          </tidy-row>
        </div>
      }

      @if (!isMultiple) {
        <tidy-card>
          <tidy-row
            class="text-center extra-bottom-padding"
            >
            <tidy-image
              class="full-width"
              [src]="photoUrls[0]"
            />
          </tidy-row>
          <tidy-row>
            <tidy-input
              [label]="'Add the photo caption'"
              [icon]="'assets/svg/camera-outline.svg'"
              [activeIcon]="'assets/svg/camera-outline-tidy-green.svg'"
              [(ngModel)]="caption"
              [form]="formControl" />
          </tidy-row>
          <tidy-row class="text-center">
            <tidy-text
              [body]="'Retake Photo'"
              class="link red"
              (action)="retakeImage()"
            />
          </tidy-row>
        </tidy-card>
      }

      <tidy-row>
        @if (errorMessage?.length) {
          <tidy-error-message
            [text]="errorMessage"
            />
        }
      </tidy-row>

      @if (!isMultiple) {
        <tidy-button
          [action]="boundSave"
          [text]="'Save'"
          class="primary"
          />
      }
    </tidy-wrapper>
  </div>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
